export default "__VITE_ASSET__e0391053__"